import { service } from "../../../services";
const state = {
  items: [],
  loading: false,
  error: null
};

const mutations = {
  setMerchants(state, merchant) {
    state.items = merchant;
  },

  setLoading(state, loading) {
    state.loading = loading;
  },

  setError(state, error) {
    state.error = error;
  }
};

const actions = {
  async fetchMerchants({ commit }) {
    const res = await service.get("/merchants");
    commit("setMerchants", res.items);
  },

  async fetchOne({ commit }, merchantId) {
    const res = await service.get(`/merchants/${merchantId}`);
    return res;
  },

  async searchMerchants({ commit }, searchTerm) {
    commit("setLoading", true);
    const res = await service.get("/merchants?search=" + searchTerm);
    commit("setMerchants", res.items);
    commit("setLoading", false);
  },

  fetchOutletsForMerchant({ commit }, merchantId) {
    try {
      return service.get("/outlets?merchant=" + merchantId);
    } catch (err) {
      commit("setError", err);
    }
  },

  async createMerchant({ commit, dispatch }, payload) {
    try {
      await service.put(`/merchants/${payload.id}`, payload);
      dispatch("cropper/clear", { root: true });
      dispatch("fetchMerchants");
    } catch (err) {
      commit("setError", err);
    }
  }
};

export const merchants = {
  namespaced: true,
  state,
  actions,
  mutations
};
